// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: producer/producer_kind.proto

/* eslint-disable */

export const protobufPackage = "producer";

export enum ProducerKind {
  PRODUCER_KIND_UNSPECIFIED = 0,
  PRODUCER_KIND_AUDIO = 1,
  PRODUCER_KIND_VIDEO = 2,
  UNRECOGNIZED = -1,
}

export function producerKindFromJSON(object: any): ProducerKind {
  switch (object) {
    case 0:
    case "PRODUCER_KIND_UNSPECIFIED":
      return ProducerKind.PRODUCER_KIND_UNSPECIFIED;
    case 1:
    case "PRODUCER_KIND_AUDIO":
      return ProducerKind.PRODUCER_KIND_AUDIO;
    case 2:
    case "PRODUCER_KIND_VIDEO":
      return ProducerKind.PRODUCER_KIND_VIDEO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProducerKind.UNRECOGNIZED;
  }
}

export function producerKindToJSON(object: ProducerKind): string {
  switch (object) {
    case ProducerKind.PRODUCER_KIND_UNSPECIFIED:
      return "PRODUCER_KIND_UNSPECIFIED";
    case ProducerKind.PRODUCER_KIND_AUDIO:
      return "PRODUCER_KIND_AUDIO";
    case ProducerKind.PRODUCER_KIND_VIDEO:
      return "PRODUCER_KIND_VIDEO";
    case ProducerKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
